@if (areLabelsLoaded()) {
  @for (favoriteLabel of favoriteLabels(); track favoriteLabel.value) {
    <pxc-label
      [attr.data-testid]="'label-' + favoriteLabel.display"
      [clickable]="true"
      [label]="favoriteLabel.value"
      (click)="labelPicked.emit(favoriteLabel)" />
  }
} @else {
  @for (placeholder of skeletonPlaceholders; track $index) {
    <pxc-label [loading]="true" />
  }
}
